import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDataset } from './tabular-type.dataset';

import { CassandraLinkedService } from 'app/model/linkedservice/cassandra.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.cassandra.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Cassandra_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Cassandra_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: CassandraLinkedService.MODEL // Linked service redefined
        }
    }
})
export class CassandraDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
    public static readonly KEY_SPACE: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_KeySpace,
        association: 'KEY_SPACE',
        templatable: true
    })
    public keySpace?: string;
    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
